import Mediator from 'gisw/Classes/Mediator';
import parseHtml from 'gisw/Helpers/html';
import messageObserver from 'gisw/Widgets/MessageManager/MessageObserver';

import SearchUtility from '../GenericSearch/SearchUtility';

class PaymentSearch {
  isWindowOpen = false;

  /** @type {HTMLDivElement} */
  parentDom = null;

  constructor (config) {
    Object.assign(this, config);

    this.searchUtil = new SearchUtility();

    if (
      Mediator.toolsManager.hasTool(
        'PersonalProperty',
        Mediator.getCurrentTabName()
      )
    ) {
      Mediator.toolsManager.bootUpPersonalProperty();
    }

    $.ajax({
      async: false,
      type: 'GET',
      url: 'PaymentSearch',
      success: data => {
        // @ts-ignore
        this.parentDom =
          typeof data === 'string' ? parseHtml(data).item(0) : data;
      }
    });
  }

  onSubmitPaymentSearch () {
    Mediator.handle({ name: 'loading.show' });

    const searchedType = $('#SelectedPaymentType').val();

    $.ajax({
      async: false,
      type: 'POST',
      url: 'PaymentSearch',
      data: $('#PaymentSearchForm').serialize(),
      success: data => {
        this.onSearchSuccess(data, searchedType);
      }
    });
  }

  onSearchSuccess (data, searchedType) {
    let results;

    if (searchedType === '1') {
      results = this.searchUtil.resultSetFromPids(data);
    } else {
      results = this.searchUtil.addMapping(data, null);
    }

    if (results.isEmpty()) {
      messageObserver.broadcast({
        title: 'No Results',
        message: 'Nothing matched your search criteria.'
      });
      return;
    }

    Mediator.handle({ name: 'results.clear', args: [] });

    Mediator.handle({ name: 'search.results.show', args: [results, true] });
  }

  getDomNode () {
    return this.parentDom;
  }
}

export default PaymentSearch;
